/// <reference types="resize-observer-browser" />
import { useEffect, useState, useRef } from 'react'
import style from './style.scss'

type Props = {
  affiliateList: React.ReactNode
  dailyItemList: React.ReactNode
  courseList: React.ReactNode
}

function StandardDailyList(props: Props) {
  const resizeObserver = useRef<ResizeObserver | null>(null)
  const [height, setHeight] = useState<number | string>('auto')
  const dailyRef = useRef<HTMLDivElement>(null)
  const { affiliateList, dailyItemList, courseList } = props

  useEffect(() => {
    resizeObserver.current = new ResizeObserver(
      (entries: ResizeObserverEntry[]) => {
        for (const entry of entries) {
          if (entry.target === dailyRef.current) {
            const element = entry.target as HTMLDivElement
            setHeight(element.offsetHeight)
          }
        }
      },
    )

    if (dailyRef.current) {
      resizeObserver.current.observe(dailyRef.current)
    }

    return () => {
      if (resizeObserver.current) {
        resizeObserver.current.disconnect()
      }
    }
  }, [])

  return (
    <div className={style.wrapper} style={{ height }}>
      <div className={style.affiliateList}>{affiliateList}</div>
      <div className={style.dailyItemList} ref={dailyRef}>
        {dailyItemList}
      </div>
      <div className={style.courseList}>{courseList}</div>
    </div>
  )
}

export default StandardDailyList
